import React, { useMemo } from 'react';
import Typography from '@justpark/ui/src/components/Typography';
import FAQs from '@justpark/ui/src/components/FAQs';
import BrandTypography from '@justpark/ui/src/components/BrandTypography';
import Heading from '@justpark/ui/src/components/Heading';
import CmsContent from '../CmsContent';

import styles from '../../../static/scss/components/landing/faqsBlock.module.scss';

type Faq = {
  question: string,
  answer: string
};

type Props = {
  heading: string,
  description: string,
  body: string,
  faqs: Array<Faq>,
  isSingleColumn: boolean
};

const FaqBlock = ({
  heading,
  description,
  body,
  faqs,
  isSingleColumn
}: Props) => {
  const parsedFaqs = useMemo(
    () =>
      faqs.map(({ question, answer }) => ({
        question,
        answer: (
          <Typography key={question}>
            <div>
              <CmsContent content={answer} />
            </div>
          </Typography>
        )
      })),
    [faqs]
  );

  const singleColumnClass = isSingleColumn ? styles.singleColumn : '';

  return (
    <div className={`${styles.base} ${singleColumnClass}`}>
      <div className={styles.half}>
        <BrandTypography level={2} bold>
          {heading}
        </BrandTypography>
        <Heading level={3} className={styles.description} bold>
          <p>{description}</p>
        </Heading>
        <Typography>
          <span>
            <CmsContent content={body} />
          </span>
        </Typography>
      </div>
      <div className={styles.half}>
        <FAQs faqs={parsedFaqs} />
      </div>
    </div>
  );
};

export default FaqBlock;
